import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_CLIENT_ITEM_RESET = 'POST_CLIENT_ITEM_RESET';
export const POST_CLIENT_ITEM_LOADING = 'POST_CLIENT_ITEM_LOADING';
export const POST_CLIENT_ITEM_SUCCESS = 'POST_CLIENT_ITEM_SUCCESS';
export const POST_CLIENT_ITEM_REJECT = 'POST_CLIENT_ITEM_REJECT';

//* ACTIONS ------------------------------------------------
export const postClientItemReset = () => ({ type: POST_CLIENT_ITEM_RESET });
export const postClientItemLoading = () => ({ type: POST_CLIENT_ITEM_LOADING });
export const postClientItemSuccess = (payload) => ({ type: POST_CLIENT_ITEM_SUCCESS, payload });
export const postClientItemReject = (payload) => ({ type: POST_CLIENT_ITEM_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postClientItemRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        data,
    }, getState);
    return request(`/api/Items/CreateClientItem`, options);
};
